import * as React from 'react';

import { Field } from 'redux-form';

import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import type { JobFieldProps } from './job-field';

import { normalizeToTwoDigits } from '../../businesslogic/form-normalizers';

import { JobField } from './job-field';

import { TextField } from '../../widgets/redux-form-fields/material-ui-wrappers';

type InputProps = {
  job: Job;
  jobDetails: JobDetails;
};

type Props = InputProps & JobFieldProps;

const minValue = (min: number) => (value: number) => {
  if (value && value < min) {
    return `Must be at least ${min}`;
  }
  return undefined;
};

export class JobFieldOtherApplicantRequirements extends React.PureComponent<Props> {
  render() {
    const { job } = this.props;
    const childrenProps = { ...this.props };
    return (
      <JobField
        {...childrenProps}
        title="Other Applicant Requirements"
        caption="These settings impact the questions we ask applicants to make sure you have all the information you need."
        editView={
          <Grid container>
            <Grid
              item
              xs={12}
              style={{
                padding: '0 8px',
              }}
            >
              <FormControl>
                <FormControlLabel
                  control={
                    <Field
                      className="u-width-50px"
                      name="minimumAge"
                      type="number"
                      component={TextField}
                      normalize={normalizeToTwoDigits}
                      validate={[minValue(14)]}
                    />
                  }
                  label="Minimum age"
                />
              </FormControl>
            </Grid>
          </Grid>
        }
        displayView={
          <Grid container>
            {!job.minimumAge && (
              <Grid item xs={12}>
                <Typography variant="body2">
                  This job has no additional applicant requirements.
                </Typography>
              </Grid>
            )}
            {job.minimumAge && (
              <Grid item xs={12}>
                <Typography variant="body2">
                  This job has a minimum age of {job.minimumAge}.
                </Typography>
              </Grid>
            )}
          </Grid>
        }
      />
    );
  }
}
